var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_1503)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 73.5,
    r: 62.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 36C69.0832 36 61.833 38.1993 55.6661 42.3199C49.4993 46.4404 44.6928 52.2971 41.8545 59.1494C39.0162 66.0016 38.2736 73.5416 39.7206 80.8159C41.1675 88.0902 44.739 94.772 49.9835 100.016C55.228 105.261 61.9098 108.832 69.1841 110.279C76.4584 111.726 83.9984 110.984 90.8506 108.145C97.7029 105.307 103.56 100.501 107.68 94.3339C111.801 88.167 114 80.9168 114 73.5C114 68.5754 113.03 63.6991 111.145 59.1494C109.261 54.5997 106.499 50.4657 103.017 46.9835C99.5343 43.5013 95.4003 40.7391 90.8506 38.8545C86.3009 36.97 81.4246 36 76.5 36ZM92.625 64.5375L75.4875 87.0375C75.1382 87.4913 74.6895 87.8591 74.176 88.1126C73.6625 88.3661 73.0977 88.4986 72.525 88.5C71.9554 88.5031 71.3926 88.3763 70.8793 88.1294C70.366 87.8825 69.9157 87.5219 69.5625 87.075L60.4125 75.4125C60.1097 75.0234 59.8864 74.5786 59.7555 74.1032C59.6245 73.6279 59.5885 73.1315 59.6494 72.6422C59.7104 72.153 59.8671 71.6805 60.1106 71.2518C60.3541 70.8231 60.6797 70.4466 61.0688 70.1437C61.8545 69.5321 62.851 69.2576 63.8391 69.3807C64.3283 69.4416 64.8008 69.5983 65.2294 69.8418C65.6581 70.0854 66.0346 70.4109 66.3375 70.8L72.45 78.6L86.625 59.85C86.9254 59.456 87.3005 59.1251 87.7288 58.8761C88.1571 58.627 88.6302 58.4648 89.1212 58.3987C89.6122 58.3325 90.1114 58.3637 90.5903 58.4905C91.0693 58.6172 91.5185 58.8371 91.9125 59.1375C92.3065 59.4379 92.6374 59.8129 92.8864 60.2412C93.1354 60.6695 93.2977 61.1427 93.3638 61.6337C93.43 62.1247 93.3988 62.6239 93.272 63.1028C93.1453 63.5818 92.9254 64.031 92.625 64.425V64.5375Z",
    fill: "#3EBF0F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_1503",
    x: 0.464968,
    y: 0.649681,
    width: 152.07,
    height: 152.07,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.18471
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.76752
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.136774 0 0 0 0 0.433333 0 0 0 0 0.0287248 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_1503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_1503",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.daa41463e642308836ad2a878131dd64.svg";
export { ForwardRef as ReactComponent };